import { APP_ROUTES } from '@routes/routes.constants';

export const NO_DEEP_LINK_PATHS: readonly string[] = [
  APP_ROUTES.DEFAULT,
  APP_ROUTES.APP_INITIALIZER,
];

/** Only same-origin relative paths; `//host` and `/\host` are protocol-relative open redirects. */
export function isSafeRelativeUrl(url: string): boolean {
  return url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/\\');
}
